import * as React from "react";
function SvgNumber2(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M35.3 22c4.5-6.2 3-14.9-3.2-19.4s-14.9-3-19.4 3.2c-3.4 4.8-3.5 11.2-.1 16l.1.1L2.3 41.3l9.7-3.1 2.8 9.8L24 30.8 33.2 48l2.8-9.8 9.7 3.1L35.3 22zM13 11.9c.9-5.4 5.6-9.3 11-9.3.7 0 1.4.1 2 .2 6.1 1.1 10.2 6.9 9.1 13s-6.9 10.2-13 9.1C16 23.8 11.9 18 13 11.9zm2.5 29l-1.6-6.1-6 1.9L14.7 24c2 1.8 4.4 3 7 3.5l.9.1-.2.1.2.3-7.1 12.9zm18.7-6.1l-1.8 6.1L25.5 28l.2-.3-.2-.1c2.9-.3 5.7-1.6 7.9-3.6l6.8 12.6-6-1.8zm-5.9-15.5h-8.6v-2.1l2.9-2.9c.8-.9 1.4-1.5 1.6-1.8.2-.2.4-.5.5-.8.1-.2.2-.5.2-.7 0-.3-.1-.5-.3-.7-.2-.2-.5-.3-.8-.3-.4 0-.8.1-1.1.3-.5.3-.9.6-1.4 1l-1.8-2.1L21 8c.4-.2.9-.4 1.3-.5.6-.2 1.2-.2 1.7-.2.7 0 1.4.1 2.1.4.5.3 1 .6 1.3 1.1.3.5.5 1.1.5 1.7 0 .9-.2 1.7-.7 2.5-.3.5-.6.9-1 1.3s-1.2 1.2-2.5 2.4h4.4l.2 2.6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgNumber2);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
